import { useMemo } from 'react';
import { useSelector } from 'react-redux'; // @ts-expect-error Could not find a declaration file for module

import { useFetchFilters } from '../../hooks/catalogPageHooks'; // @ts-expect-error no types

import { getNewFavouriteName } from '../../selectors/favoriteSelectors';
import { useParams } from 'react-router-dom';
import { useWatchLater } from '.';
export const useFavorites = () => {
  const {
    watchLaterItems,
    watchLaterLoading,
    watchLaterError
  } = useWatchLater();
  const hasFavorites = watchLaterItems !== null && watchLaterItems.length > 0;
  const {
    tracksLessonsSearchQueryData,
    tracksLessonsSearchQueryLoading,
    tracksLessonsSearchQueryError,
    searchQueryParams
  } = useFetchFilters();
  const favoritedItems = useMemo(() => watchLaterItems && tracksLessonsSearchQueryData ? watchLaterItems.filter(watchLaterItem => {
    const {
      contentId: watchLaterItemId,
      contentType: watchLaterItemType
    } = watchLaterItem;
    return tracksLessonsSearchQueryData.find(({
      id,
      contentType
    }) => Number(id) === watchLaterItemId && contentType === 'TRACK' ? watchLaterItemType === 'TRACK' : watchLaterItemType !== 'TRACK');
  }) : null, [tracksLessonsSearchQueryData, watchLaterItems]);
  return {
    hasFavorites,
    favoritedItems,
    favoritedItemsLoading: watchLaterLoading || tracksLessonsSearchQueryLoading,
    favoritedItemsError: watchLaterError || tracksLessonsSearchQueryError,
    searchQueryParams
  };
};
export const useFavoritesTooltip = () => {
  const {
    title,
    added
  } = useSelector(getNewFavouriteName);
  return {
    show: !!title,
    title,
    added
  };
};
export const useFavoritesParams = () => {
  const {
    page: pageParam
  } = useParams();
  return {
    page: Number(pageParam) || 1
  };
};